export default __webpack_public_path__ + "static/media/create.877e7b30.png";